export const words = {
  place: "Местоположение",
  yes: "Да",
  no: "Не",
  new: "Нов",
  agb: 'AGB',
  agb_full: "Общи правила и условия",
  datenschutzerklaerung: "Политика за поверителност",
  status: "Статус",
  company_name: "Име на компанията",
  next_button: "Още",
  device_name: "Име на устройството",
  to_connect: "Свържете",
  pin: 'PIN',
  time: "Време",
  first_name: "Първо име",
  last_name: "Фамилия",
  code: "Код",
  help: "Помощ",
  total_time: "Общо време",
  latitude: "Географска ширина",
  longitude: "Дължина",
  accuracy: "Точност",
  timestamp: "Времеви печат",
  device_id: "Идентификатор на устройството",
  active: "активен",
  o_clock: "Часовник",
  loading: "Магазин",
  annotation: "Забележка",
  since: "от",
  camera: "Камера",
  map: "Карта",
  gallery: "Галерия",
  work: "Работа",
  employees: "Служители",
  login: "Регистрация",
  login_action: "Влезте в системата",
  calendar_week_abbreviation: 'KW',
  calendar: "Календар",
  to_call: "Обадете се на",
  email: "Електронна поща",
  attachment: "Приложение",
  operational_planning: "Оперативен план",
  to_scan: "Сканиране",
  download: "Изтегляне",
  export: "Експорт",
  to_document: "Документ",
  checklist: "Контролен списък",
  checklists: "Контролни списъци",
  password: "Парола",
  confirmation: "Потвърждение",
  confirm: "Потвърдете",
  confirmation_email: "Имейл за потвърждение",
  unknown: "Неизвестен",
  unknown_place: "Неизвестно местоположение",
  unknown_plan: "Неназован график на смени",
  project_no: "Проект №.",
  project_file: "Файл на проекта",
  contact_person: "Свържете се с",
  overtime: "Извънреден труд",
  timesheet: "Разписание",
  minustime: "Минус часове",
  back: "Обратно",
  undo: "Отмяна на",
  clockout: "Подпечатайте се",
  clocked_out: "щампован",
  clockin: "Печат в",
  clocked_in: "щампован",
  dismiss: "Отмяна на",
  discard: "Отхвърлям",
  finish: "Готов",
  or: "или",
  copy: "Копирам",
  qr_code: "QR код",
  documentation: "Записване на времето и документация",
  attendance: "Терминал за таблети",
  tiercontent: "Обхват на пакета",
  start_now: "Започнете сега",
  skip: "прескочете",
  logout_during_core_time: "Отпечатани по време на основната работа",
  absent_during_core_time: "Отсъства по време на основното време",
  distance: "Разстояние",
  km_reading: "Пробег",
  the_start: "Начало",
  the_end: "Край на",
  license_plate: "Табела с регистрационен номер",
  details: "подробности",
  hide: "скрий",
  cost: "Разходи",
  file: "Файл",
  address_book: "Адресна книга",
  template_plural: "Шаблони",
  signature: "Подпис",
  main_project: "Основен проект",
  main_projects: "Основни проекти",
  sub_projects: "Подпроекти",
  scan_to_login_header: "Регистрация на QR код",
  description: "Описание",
  project_location: "Местоположение на проекта",
  phone_number: "Телефонен номер",
  project_info: "Информация за проекта",
  number_short: "Не.",
  sketch: "Скица",
  video: "Видео",
  delete: "Изтриване на",
  send: "Изпрати",
  sending: "Изпращам...",
  save: "Запазете",
  granted: "одобрен",
  pending: "заявени",
  denied: "Отхвърлени",
  customer: "Клиент",
  mobile_number: "Телефонен номер",
  ok: "Добре",
  day: "Ден",
  tomorrow: "Сутрин",
  days: "Дни | Ден | Дни",
  holidays: "Празници",
  vacation_days: "Празници",
  vacation_hours: "Ваканционно време",
  request: "Заявка",
  accept: "Приемане на",
  withdraw: "Оттегли",
  hour_account: "Почасова сметка",
  period: "Период",
  to: "към",
  date: "Назначаване",
  number: "Номер",
  message: "Съобщение",
  change: "промяна",
  changed: "Промени",
  changed_fields: "Променени полета",
  type: "Изкуство",
  hour: "Час",
  hours: "Часове",
  hours_abbreviation: "Стандартно.",
  hours_with_amount: "{amount} Часове",
  end: "край",
  end_date: "Краен срок",
  start_date: "Начална дата",
  absence: "Отсъствие",
  month: "месец",
  week: "Седмица",
  transcript: "Препис",
  time_left: "останал",
  transcript_tasks: "Задачи",
  add_task: "Нов",
  /** Differentiation in some languages (e.g. English) */
  from: "от",
  of: "от",
  of_hours: "от {hours} часа",
  of_hours_abbreviation: "{hours} от часове.",
  /**************/

  used: "използван",
  update: "Актуализация",
  today: "днес",
  correction: "Корекция",
  work_time: "Работно време",
  break: "Прекъсване",
  loading_time: "Време за зареждане",
  driving_time: "Време за пътуване",
  business_trip: "Служебно пътуване",
  project: "Проект",
  special_one: "Специален1",
  special_two: "Специално2",
  clock: "Часовник",
  search: "Търсене",
  operation: "Дейност",
  day_protocol: "Дневен протокол",
  continue: "повече",
  total_duration: "Общо време",
  duration: "Продължителност",
  hello: "Здравейте",
  close: "затворете",
  comment: "Коментар:",
  small: "малък",
  medium: "среден",
  large: "голям",
  sharpie: "Пин",
  line: "Линия",
  arrow: "Стрелка",
  rectangle: "Правоъгълник",
  ellipse: "Елипса",
  text: "Текст",
  language_settings: "Езикови настройки",
  clock_reminder: "Напомняне за печата",
  individually: "Индивидуален",
  from_o_clock: "от",
  to_o_clock: "към",
  eraser: "Гумичка",
  edit: "Редактиране на",
  legal_notes: "Юридически",
  notes: "Бележки",
  note: "Забележка",
  imprint: "Отпечатък",
  open_source_licenses: "Лицензионни условия за отворен код",
  author: "Автор",
  license_type: "Вид лиценз",
  version: "Версия",
  substitute: "Представителство",
  not_rated: "Не е оценен",
  weekly_working_hours: "Седмични работни часове",
  show_less: "Покажи по-малко",
  office_center: "Офис център",
  admin_view: "Управление на NFC",
  register: "Регистрирайте се",
  shifts: {
    shift_attachments: "Прикачени елементи (слой)",
    shift_plan_attachments: "Прикачени файлове (план за смяна)",
    shift_plan: "График на смени",
    shift: "Слой"
  },
  absences: {
    sick: "Болест (продължаващо изплащане на заплати)",
    vacation: "Ваканция",
    workshop: "Семинар/курс",
    special_vacation: "Специален отпуск",
    school: "Училище",
    working_time_account: "Сметка за работно време",
    holiday: "Ваканция",
    other: "Други",
    driving_time: "Време за пътуване",
    parental_leave: "Родителски отпуск",
    excused_absent: "Отсъстващи извинени (платени)",
    not_excused_absent: "Отсъствие без извинение",
    sick_industrial_accident: "Болест Промишлена злополука (LFZ)",
    short_time_work: "Краткосрочна работа (Kug)",
    maternity_pay: "Защита на майчинството Забрана за заплата/заетост",
    sick_child: "Грижа за болно дете с болнично (дневно) възнаграждение",
    sick_child_no_payment: "Грижи за болно дете без заплащане на болничен (дневен)",
    vacation_no_payment: "Неплатен отпуск",
    sick_before_short_time_work: "Обезщетение за болест/болест преди Kug",
    weather_related_failure: "Неуспех поради метеорологични условия",
    sick_short_time_work: "Заболяване по време на Kug",
    sick_no_payment: "Болест (без продължаване на изплащането на заплатите)",
    company_vacation: "Почивки в компанията",
    meals_14_euro: "Малка сума за кетъринг",
    meals_28_euro: "Голяма сума за кетъринг"
  },
  image_editor: {
    font_size: "Размер на шрифта",
    stroke_width: "Ширина на линията",
    stroke_color: "Цвят на линията",
    text_color: "Цвят на шрифта",
    rotate_left: "Завъртете наляво",
    rotate_right: "Завъртете надясно",
    flip_horizontal: "Огледало в хоризонтално положение",
    flip_vertical: "Вертикално огледало"
  },
  travel_log: {
    method_of_transportation: "Средства за транспорт",
    company_car: "Служебен автомобил",
    private_car: "Личен автомобил",
    rental_car: "Автомобил под наем",
    taxi: "Такси",
    public_transportation: "Обществен транспорт",
    airplane: "Аероплан",
    train: "Железопътен транспорт (обществен транспорт на дълги разстояния)",
    other: "Други",
    km_reading_start: "Начало на пробега",
    km_reading_end: "Край на пробега",
    net_expenses: "Пътни разходи (нето)",
    tax: "Данък върху добавената стойност"
  },
  read_in: "Прочетете в",
  currency: "Валута",
  reason: "Причина",
  label: "Етикет",
  monday: "Понеделник",
  tuesday: "Вторник",
  wednesday: "Сряда",
  thursday: "Четвъртък",
  friday: "Петък",
  saturday: "Събота",
  sunday: "Неделя",
  break_alarm: "Счупи будилника",
  clockin_reminder: "Напомняне за пристигане",
  clockout_reminder: "Напомняне за отписване"
};